import { PropsWithChildren } from 'react';
import { theme } from '@frontend/theme';

type Props = PropsWithChildren<{
  className?: string;
}>;

export const SettingsPanelBody = ({ children, className }: Props) => {
  return (
    <div
      className={className}
      css={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: theme.spacing(2),
        overflow: 'hidden auto',
        padding: theme.spacing(2),
      }}
    >
      {children}
    </div>
  );
};
